import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "convex/_generated/api";

function AdminLayout() {
  const { data: user, isLoading } = useQuery(
    convexQuery(api.users.getCurrent, {}),
  );

  if (isLoading) return null;
  if (!user?.isSuperUser) return <Navigate to="/" />;

  return <Outlet />;
}

export const Route = createFileRoute("/$workspaceSlug/admin")({
  component: AdminLayout,
});
